import React from 'react';
import { BarChart3 } from 'lucide-react';

/**
 * Standardised empty state for all analytics drawers.
 * Renders consistently when data fails to load or is null.
 */
const AnalyticsEmptyState = ({ icon: Icon = BarChart3, title = 'No Analytics Available', message, onRetry }) => (
    <div className="text-center py-12 text-gray-500">
        <div className="bg-gray-50 rounded-lg p-6 max-w-sm mx-auto border border-gray-200">
            <Icon className="w-10 h-10 text-gray-400 mx-auto mb-3" />
            <h3 className="text-gray-900 font-medium mb-1">{title}</h3>
            <p className="text-sm text-gray-500">
                {message || "We couldn't load analytics at this time."}
            </p>
            {onRetry && (
                <button
                    onClick={onRetry}
                    className="mt-3 px-4 py-1.5 text-sm font-medium text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
                >
                    Try Again
                </button>
            )}
        </div>
    </div>
);

export default AnalyticsEmptyState;
